import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ArrowBack, ChevronRightRounded, ExpandLessRounded, InfoOutlined, InsertLinkOutlined } from "@mui/icons-material";
import { Box, Chip, Grid, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { v4 } from "uuid";
import { DownloadSvgIcon, ShareLineSvgIcon } from "../../../../assets/customIcons";
import { DeleteIcon } from "../../../../assets/images";
import { DynamicFormBuilderContainer } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { LOCAL_STORAGE_KEYS } from "../../../../constants";
import { faintblue, gray } from "../../../../theme/palette";
import { systemColor } from "../../../../theme/systemColor";
import { getLocalStorageItem } from "../../../../utils/storageHelper";
import { dateFormate, isLoaderActive } from "../../../../utils/utils";
import { getWarehouseListAPICall } from "../../../journalVoucher/services/apiCalls";
import { SpareIssuesKeys } from "../../../spareIssue/services/entity";
import { PrintIconSVG } from "../assets/customIcons";
import { DiscardDocumentModal } from "../components/DiscardDocumentModal";
import PartDetailsPR from "../components/partDetailsPR";
import { departmentListAPICall, procurmentTypeListAPICall, purchaseRequisitionAttachmentDelete, purchaseRequisitionCreateAPICall, purchaseRequisitionGetAPICall, purchaseRequisitionUpdateAPICall, supplierListAPICall, uploadPurchaseRequisitionAttachment } from "../services/apiCall";
import { PurchaseRequisitionKeys, PurchaseRequisitionMandatoryFeilds } from "../services/entity";
export var CreatePurchaseRequisition = function () {
    var _getLocalStorageItem, _getLocalStorageItem2, _getLocalStorageItem3, _crud$PurchaseRequisi, _crud$PurchaseRequisi2, _crud$PurchaseRequisi3;
    var _a = useState(false), openDiscardPopUp = _a[0], setOpenDiscardPopUp = _a[1];
    var searchParams = useSearchParams()[0];
    var id = useParams().id;
    var mode = searchParams.get('mode');
    var navigate = useNavigate();
    var UserParentOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.ParentOrganizationId;
    var UserOrganization = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.OrganizationId;
    var UserIdentity = (_getLocalStorageItem3 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem3 === void 0 || (_getLocalStorageItem3 = _getLocalStorageItem3.data) === null || _getLocalStorageItem3 === void 0 ? void 0 : _getLocalStorageItem3.IdentityId;
    var crud = useSelector(function (state) { return state.crud; });
    var data = (_crud$PurchaseRequisi = crud[PurchaseRequisitionKeys.Get]) === null || _crud$PurchaseRequisi === void 0 ? void 0 : _crud$PurchaseRequisi.data;
    var getWarehouseListByTentantId = function (params) { return getWarehouseListAPICall(_objectSpread(_objectSpread({}, params), {}, {
        request: {
            TenantId: UserOrganization
        }
    })); };
    var getSupplierByParentOrganization = function (param) { return supplierListAPICall(_objectSpread(_objectSpread({}, param), {}, {
        request: {
            ParentOrganizationId: UserParentOrganization
        }
    })); };
    var isDisabled = mode !== 'add' ? false : false;
    var generalTab = [{
            type: FormItemTypes.CardComponent,
            name: "GeneralTabs",
            label: "General Tabs",
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'PurchaseProcurementTypeId',
                    label: 'PR Type',
                    valueExpr: "id",
                    displayExpr: "DisplayName",
                    getListData: procurmentTypeListAPICall,
                    apiKey: PurchaseRequisitionKeys.ProcurementTypeList,
                    disabled: isDisabled,
                    required: true
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'DepartmentId',
                    label: 'Department',
                    getListData: departmentListAPICall,
                    apiKey: PurchaseRequisitionKeys.DepartmentList,
                    disabled: isDisabled
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'SupplierId',
                    label: 'Supplier',
                    disabled: mode === "edit",
                    getListData: getSupplierByParentOrganization,
                    apiKey: PurchaseRequisitionKeys.SupplierList,
                    setFormState: function (prev) { return ({
                        PurchaseProcurementDetails: [{
                                id: 1
                            }]
                    }); }
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'ReferenceNumber',
                    label: 'Reference no.',
                    maxLength: 100,
                    disabled: isDisabled
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'ProcurementPriorityId',
                    label: 'Priority',
                    disabled: isDisabled,
                    options: (_crud$PurchaseRequisi2 = (_crud$PurchaseRequisi3 = crud[PurchaseRequisitionKeys.PriorityList]) === null || _crud$PurchaseRequisi3 === void 0 ? void 0 : _crud$PurchaseRequisi3.data) !== null && _crud$PurchaseRequisi2 !== void 0 ? _crud$PurchaseRequisi2 : [],
                    setFormState: function (formValues, currValue) {
                        return {
                            ProcurementPriority: currValue
                        };
                    }
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'PriorityRemarks',
                    label: "Priority reason (0/150 characters)",
                    placeholder: "Enter Priority reason",
                    maxLength: 150,
                    multiline: true,
                    disabled: isDisabled,
                    minRows: 2,
                    setFieldProps: function (formValues, value) {
                        var _formValues$Procureme, _formValues$Procureme2, _value$length;
                        return {
                            type: this.type,
                            containerProps: {
                                display: (formValues === null || formValues === void 0 || (_formValues$Procureme = formValues.ProcurementPriority) === null || _formValues$Procureme === void 0 ? void 0 : _formValues$Procureme.Name) !== 'High' ? 'none' : 'unset'
                            },
                            required: (formValues === null || formValues === void 0 || (_formValues$Procureme2 = formValues.ProcurementPriority) === null || _formValues$Procureme2 === void 0 ? void 0 : _formValues$Procureme2.Name) !== 'High',
                            label: "Priority reason (".concat((_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0, "/150 characters)")
                        };
                    }
                }],
            columnSize: 12
        }, {
            type: FormItemTypes.Custom,
            name: "PurchaseProcurementDetails",
            validator: function (values, state) {
                var error = undefined;
                values === null || values === void 0 || values.find(function (r) {
                    var _Object$keys;
                    var errorField = (_Object$keys = Object.keys(PurchaseRequisitionMandatoryFeilds)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.find(function (field) { return typeof r[field] !== 'number' && typeof r[field] !== 'boolean' && !r[field]; });
                    if (errorField) {
                        error = {
                            id: v4(),
                            rowId: r.id,
                            field: PurchaseRequisitionMandatoryFeilds[errorField],
                            message: 'This field is required',
                            value: r[errorField]
                        };
                    }
                    return Boolean(errorField);
                });
                return error;
            },
            element: PartDetailsPR,
            columnSize: 12
        }, {
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            variant: 'outlined',
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    columnSize: true
                }, {
                    type: FormItemTypes.Button,
                    name: 'GrandTotal',
                    columnSize: 4,
                    children: /*#__PURE__*/ React.createElement(Typography, {
                        sx: {
                            flexGrow: 1
                        },
                        fontWeight: "bold",
                        textAlign: "left"
                    }, "Grand Total"),
                    variant: 'outlined',
                    fullWidth: true,
                    sx: {
                        justifyContent: 'space-between',
                        bgcolor: 'rgba(0,0,0,0.05)',
                        fontWeight: 'bold',
                        color: systemColor.secondary
                    },
                    setFieldProps: function (formValues, currValue) {
                        var _formValues$PurchaseP, _totalSum$toFixed;
                        var totalSum = formValues === null || formValues === void 0 || (_formValues$PurchaseP = formValues.PurchaseProcurementDetails) === null || _formValues$PurchaseP === void 0 ? void 0 : _formValues$PurchaseP.reduce(function (acc, data) {
                            return acc + data.Quantity * data.Rate;
                        }, 0);
                        return {
                            type: this.type,
                            startIcon: formValues !== null && formValues !== void 0 && formValues.Open ? /*#__PURE__*/ React.createElement(ExpandLessRounded, null) : /*#__PURE__*/ React.createElement(ChevronRightRounded, null),
                            endIcon: "\u20B9 ".concat((_totalSum$toFixed = totalSum === null || totalSum === void 0 ? void 0 : totalSum.toFixed(2)) !== null && _totalSum$toFixed !== void 0 ? _totalSum$toFixed : '00.00')
                        };
                    },
                    setFormState: function (formValues, e, field) {
                        return {
                            Open: !(formValues !== null && formValues !== void 0 && formValues.Open)
                        };
                    }
                }]
        }];
    var additionalTab = [{
            type: FormItemTypes.CardComponent,
            name: "OtherInformation",
            label: "Other Information",
            value: null,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.DatePicker,
                            name: 'ValidTillDateTime',
                            label: 'Valid till date',
                            value: null,
                            setFieldProps: function (formValues) {
                                var _formValues$EstimateD;
                                return {
                                    type: FormItemTypes.DatePicker,
                                    maxDate: dayjs((_formValues$EstimateD = formValues === null || formValues === void 0 ? void 0 : formValues.EstimateDeliveryDateTime) !== null && _formValues$EstimateD !== void 0 ? _formValues$EstimateD : undefined)
                                };
                            }
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: 'AdditionalInformation',
                            label: 'Additional Info',
                            bgcolor: 'white',
                            spacing: 0.5,
                            alignItems: "top",
                            columnSize: 3,
                            xs: 12,
                            sm: 6,
                            md: 3,
                            elements: [{
                                    type: FormItemTypes.DateTimePicker,
                                    name: 'ScheduledDateTime',
                                    label: 'Scheduled for Purchase order',
                                    id: 'ScheduledDateTime',
                                    disabled: isDisabled,
                                    value: null,
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: 'checkboxContainer',
                                    alignItems: 'center',
                                    disabled: isDisabled,
                                    spacing: 0.5,
                                    columnSize: 12,
                                    flexWrap: 'nowrap',
                                    elements: [{
                                            type: FormItemTypes.CheckBox,
                                            name: 'IsScheduled',
                                            label: 'Do you want to schedule this for PO',
                                            disabled: isDisabled,
                                            value: false,
                                            columnSize: 0,
                                            formControlLabelProps: {
                                                sx: {
                                                    color: gray
                                                }
                                            }
                                        }, {
                                            type: FormItemTypes.IconButton,
                                            name: "info",
                                            id: "info",
                                            disabled: true,
                                            label: "",
                                            value: null,
                                            columnSize: 0,
                                            size: 'small',
                                            children: /*#__PURE__*/ React.createElement(InfoOutlined, {
                                                color: "secondary",
                                                fontSize: "small"
                                            })
                                        }]
                                }]
                        }, {
                            type: FormItemTypes.DatePicker,
                            name: 'EstimateDeliveryDateTime',
                            label: 'Expected delivery date',
                            value: null,
                            disabled: isDisabled,
                            setFormState: function () { return ({
                                ValidTillDateTime: undefined
                            }); },
                            minDate: dayjs()
                        }, {
                            type: FormItemTypes.SearchSelect,
                            name: 'OrganizationId',
                            label: 'Warehouse',
                            value: null,
                            disabled: isDisabled,
                            getListData: getWarehouseListByTentantId,
                            apiKey: SpareIssuesKeys.WarehouseList
                        }]
                }],
            columnSize: 12
        }, {
            type: FormItemTypes.CardComponent,
            name: 'NotesAndAttachments',
            label: 'Notes and attachments',
            value: null,
            columnSize: 12,
            variant: 'outlined',
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: 'DeliveryNotes',
                    label: 'Delivery Notes(0/200 characters)',
                    value: null,
                    disabled: isDisabled,
                    maxLength: 200,
                    multiline: true,
                    minRows: 3,
                    setFieldProps: function (formValues, value) {
                        var _value$length2;
                        return {
                            type: this.type,
                            label: "Delivery Notes(".concat((_value$length2 = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length2 !== void 0 ? _value$length2 : 0, "/200 characters)")
                        };
                    }
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'Remarks',
                    label: 'Remarks(0/200 characters)',
                    value: null,
                    multiline: true,
                    maxLength: 200,
                    disabled: isDisabled,
                    minRows: 3,
                    setFieldProps: function (formValues, value) {
                        var _value$length3;
                        return {
                            type: this.type,
                            label: "Remarks(".concat((_value$length3 = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length3 !== void 0 ? _value$length3 : 0, "/200 characters)")
                        };
                    }
                }, {
                    type: FormItemTypes.Attachment,
                    name: 'Attachments',
                    label: 'Add attachments',
                    placeholder: 'Upload Files',
                    disabled: isDisabled,
                    value: [],
                    inputProps: {
                        accept: 'application/*',
                        multiple: true
                    },
                    uploadAttachmentRequest: {
                        systemname: PurchaseRequisitionKeys.AttachmentSystemName
                    },
                    uploadAttachmentAPI: uploadPurchaseRequisitionAttachment,
                    deleteAttachmentAPI: purchaseRequisitionAttachmentDelete
                }]
        }];
    var tabs = [{
            id: '0',
            label: 'General',
            elements: generalTab
        }, {
            id: '1',
            label: 'Additional info',
            elements: additionalTab
        }];
    var steps = [{
            elements: generalTab
        }, {
            elements: additionalTab
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: "pageHeader",
            columnSize: 12,
            justifyContent: "space-between",
            alignItems: "center",
            spacing: 0,
            gap: 1,
            p: 2,
            elements: [{
                    type: FormItemTypes.IconButton,
                    name: "backArrow",
                    id: "backArrow",
                    label: "",
                    value: null,
                    columnSize: 0,
                    children: /*#__PURE__*/ React.createElement(ArrowBack, {
                        fontSize: "small",
                        id: 'arrow-back'
                    }),
                    onClick: function () { return navigate('/purchaseRequisition'); },
                    setFieldProps: function () { return ({
                        type: FormItemTypes.IconButton,
                        disabled: false
                    }); }
                }, {
                    type: FormItemTypes.Typography,
                    name: 'Header',
                    label: '',
                    value: null,
                    children: mode !== 'add' ? 'Purchase Requisition' : 'New Purchase Requisition',
                    columnSize: 0,
                    variant: 'h1',
                    noWrap: true
                }, mode !== "add" ? {
                    type: FormItemTypes.Custom,
                    name: 'StatusCard',
                    label: '',
                    value: null,
                    columnSize: 0,
                    element: function (_ref) {
                        var _value$Status, _value$Status2;
                        var value = _ref.value;
                        return (value === null || value === void 0 || (_value$Status = value.Status) === null || _value$Status === void 0 ? void 0 : _value$Status.Name) && /*#__PURE__*/ React.createElement(Chip, {
                            label: value === null || value === void 0 || (_value$Status2 = value.Status) === null || _value$Status2 === void 0 ? void 0 : _value$Status2.Name,
                            size: "small",
                            variant: "outlined",
                            sx: {
                                borderRadius: 2,
                                px: 1,
                                fontWeight: 'bold'
                            },
                            icon: /*#__PURE__*/ React.createElement(Box, {
                                id: "create-spare-status-box",
                                height: 8,
                                width: 8,
                                borderRadius: 10,
                                bgcolor: "gray"
                            })
                        });
                    }
                } : null, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: true,
                    item: false,
                    justifyContent: 'end',
                    spacing: 0,
                    elements: mode !== "edit" ? [] : [{
                            type: FormItemTypes.Typography,
                            name: 'DocumentNumber',
                            label: 'PR NUMBER: ',
                            value: null,
                            children: null,
                            columnSize: 0,
                            labelTypographyProps: {
                                color: 'rgba(0,0,0,0.4)',
                                fontSize: 12,
                                fontWeight: 600,
                                mb: 0
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                alignItems: 'center',
                                spacing: 0,
                                gap: 1,
                                px: 1
                            },
                            fontWeight: 400,
                            fontSize: 14
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'ProcurementCreatedDateTime',
                            label: 'PR DATE: ',
                            value: null,
                            valueGetter: function (formValues, field) { return dateFormate(formValues === null || formValues === void 0 ? void 0 : formValues.ProcurementCreatedDateTime); },
                            columnSize: 0,
                            labelTypographyProps: {
                                color: 'rgba(0,0,0,0.4)',
                                fontSize: 12,
                                fontWeight: 600,
                                mb: 0
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                alignItems: 'center',
                                spacing: 0,
                                gap: 1,
                                px: 1
                            },
                            fontWeight: 400,
                            fontSize: 14
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ActionPanel',
            columnSize: 12,
            spacing: 0,
            columnSpacing: 2,
            p: 2,
            minWidth: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignContent: 'flex-end',
            bgcolor: '#EFF2F5',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "ActionButtons",
                    columnSize: true,
                    item: false,
                    justifyContent: "flex-end",
                    spacing: 1,
                    alignItems: 'center',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'QuickLinks',
                            children: 'Quick Links',
                            columnSize: 0,
                            variant: 'text',
                            startIcon: /*#__PURE__*/ React.createElement(InsertLinkOutlined, {
                                width: '48px',
                                height: '40px',
                                id: 'quick-link-icon'
                            }),
                            disabled: isDisabled,
                            sx: {
                                background: 'none'
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: 'DownloadIcon',
                            children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                            disabled: isDisabled,
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: 'ShareIcon',
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            disabled: isDisabled,
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: 'PrintIcon',
                            children: /*#__PURE__*/ React.createElement(PrintIconSVG, null),
                            columnSize: 0,
                            disabled: isDisabled,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Box,
                            name: "",
                            columnSize: 0,
                            height: "40px",
                            width: "2px",
                            bgcolor: "rgba(0,0,0,0.1)",
                            mx: 1
                        }, {
                            type: FormItemTypes.Button,
                            name: 'Delete',
                            children: /*#__PURE__*/ React.createElement("img", {
                                src: DeleteIcon,
                                alt: "",
                                id: "deleteIcon"
                            }),
                            onClick: function (e, formValues) {
                                delete formValues.Stepper;
                                delete formValues.Delete;
                                var clone = formValues;
                                var formValueCond = Object.keys(clone).some(function (key) { return clone[key] !== null; });
                                if (formValueCond)
                                    setOpenDiscardPopUp(true);
                            },
                            disabled: isDisabled,
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: 'SaveAsDraft',
                            children: 'Save as draft',
                            disabled: isDisabled,
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: 'Save',
                            children: 'Save',
                            id: 'save',
                            disabled: isDisabled,
                            columnSize: 0,
                            variant: 'contained',
                            onClick: function () { return 'submit'; }
                        }]
                }]
        }, {
            type: FormItemTypes.Tabs,
            name: "Stepper",
            label: "",
            value: "0",
            tabs: tabs,
            valueExpr: "id",
            displayExpr: "label",
            columnSize: 12,
            variant: 'scrollable',
            tabPanelProps: {
                sx: {
                    px: {
                        xs: 2,
                        sm: 2.5,
                        md: 3
                    }
                }
            },
            sx: {
                paddingX: {
                    xs: 2,
                    sm: 2.5,
                    md: 3
                },
                gap: 2.5
            },
            stackContainerProps: {
                sx: {
                    mb: {
                        xs: 7.5,
                        sm: 0
                    }
                }
            }
        }];
    return /*#__PURE__*/ React.createElement(Grid, {
        bgcolor: faintblue
    }, isLoaderActive([PurchaseRequisitionKeys.Create, PurchaseRequisitionKeys.PartDetailsByProductId]), /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        updateFormAPI: purchaseRequisitionUpdateAPICall,
        updateKey: PurchaseRequisitionKeys.Update,
        pagingAPIKey: PurchaseRequisitionKeys.Paging,
        createKey: PurchaseRequisitionKeys.Create,
        createFormAPI: purchaseRequisitionCreateAPICall,
        createRequest: {
            OrganizationId: UserOrganization,
            Attachments: [],
            ParentOrganizationId: UserParentOrganization,
            ProcurementCreatedById: UserIdentity,
            ProcurementCreatedDateTime: new Date().toISOString(),
            ApprovedById: UserIdentity,
            IsScheduled: false
        },
        onClose: function () { return navigate("/purchaseRequisition"); },
        getFormAPI: purchaseRequisitionGetAPICall,
        getKey: PurchaseRequisitionKeys.Get,
        getRequest: {
            id: id
        },
        gridSpacing: 0
    }), openDiscardPopUp && /*#__PURE__*/ React.createElement(DiscardDocumentModal, {
        openPopUp: openDiscardPopUp,
        handleCancelClick: function () { return setOpenDiscardPopUp(false); }
        // handleDiscardClick={handleDiscardClick}
    }));
};
